import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const DENY_USER_SUCCESS = "DENY_USER_SUCCESS";

export interface DenyUserSuccessAction extends Action {
  type: typeof DENY_USER_SUCCESS;
  userId: string | number;
  organization: OrganizationKeyName;
}

export const denyUserSuccessAction = (
  organization: OrganizationKeyName,
  userId: string | number
): DenyUserSuccessAction => ({
  type: DENY_USER_SUCCESS,
  userId,
  organization,
});
